<template>
    <el-upload
            :on-success="handleAvatarSuccess"
            :show-file-list="false"
            action="/v1/api/mg/upload"
            class="avatar-uploader">
        <img :src="cpImageUrl" :style="getStyle" alt="_" class="avatar" v-if="cpImageUrl">
        <i class="el-icon-plus avatar-uploader-icon" v-else></i>
    </el-upload>

</template>

<script>
    import {filePath} from '../utils/AwsUtils'

    export default {
        name: 'IconUploader',
        props: {
            url: {required: true},
            fid: {required: false},
            setBg: {required: false}
        },
        data() {
            return {
                imageUrl: undefined,
                backColor: ''
            }
        },
        methods: {
            handleAvatarSuccess(res) {
                this.$emit('update:url', res.path)
                this.$emit('update:fid', res.id)
                this.imageUrl = res.path
            }
        },
        computed: {
            getStyle() {
                if (this.setBg) {
                    return "background: #0a609b";
                } else {
                    return ""
                }
            },
            cpImageUrl() {
                if (this.imageUrl) {
                    return filePath(this.imageUrl)
                }
                if (this.url) {
                    return filePath(this.url)
                }
                return null
            }
        }

    }
</script>

<style scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: red;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        min-width: 80px;
        height: 100px;
        min-height: 80px;
        line-height: 100px;
        text-align: center;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
    }

    .avatar {
        width: 80px;
        min-width: 80px;
        height: 80px;
        min-height: 80px;
        display: block;
    }
</style>
